import type { Arrayable } from 'element-plus/es/utils'
import type { FunctionDirective, ObjectDirective } from 'vue'
import { usePermission } from '../composables'

export const autoFocus: ObjectDirective<any, boolean> = {
  mounted(el, binding) {
    const autoFocus = binding.value ?? true
    if (!autoFocus) {
      return
    }
    setTimeout(() => {
      if (el.querySelector('.el-input__inner') != null) {
        el.querySelector('.el-input__inner').focus()
        return
      }
      el.querySelector('.el-textarea__inner').focus()
    }, 0)
  },
}

export const blur: ObjectDirective = {
  mounted(el) {
    el.addEventListener('focus', (e) => {
      e.target.blur()
    })
  },
}

export const permission: FunctionDirective<any, Arrayable<string>> = (el, binding) => {
  const { value } = binding

  const { checkPermission } = usePermission()
  if (checkPermission(value)) {
    return
  }

  el.parentNode?.removeChild(el)
}
